import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";

import { BrowserRouter } from "react-router-dom";

import { Authenticator } from "@aws-amplify/ui-react";

import { SharedStateProvider } from './context/sharedState';


const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Authenticator.Provider>
        <SharedStateProvider>
          <App />
        </SharedStateProvider>
      </Authenticator.Provider>
    </BrowserRouter>
  // </React.StrictMode>
);
